<div class="notyf__wrapper">

  <!-- Icon Section -->
  <div class="notyf__icon">
    <i class="fa-solid fa-md {{ icon }}"></i>
  </div>

  <!-- Message Content -->
  <div class="notyf__message">
    <!-- Title -->
    @if (title()) {
      <strong>{{ title() }}</strong>
    }

    <!-- Message -->
    @if (message()) {
      <p class="mb-0">{{ message() }}</p>
    }
  </div>

  <!-- Dismiss Button -->
  @if (closeBtn) {
    <div class="notyf__dismiss">
      <button class="notyf__dismiss-btn" (click)="remove()" aria-label="Dismiss notification"></button>
    </div>
  }
  
</div>

<!-- Visually Hidden Accessibility Message -->
<span class="visually-hidden">Loading...</span>